/**
 * Plan problems — every fail and warn of the last attempt, one line each with the server's message.
 * The console draws this panel only when there is at least one; a clean plan needs no panel saying so.
 */

import type { Today } from "../../api/types/competition";
import { useT } from "../../i18n/useT";

export function Checks({ today }: { today: Today }) {
  const { t } = useT();
  return (
    <div className="findings">
      {(today.run?.findings ?? []).map((f, i) => (
        <p key={`${f.check}-${i}`} className="finding" data-severity={f.severity}>
          <span className="finding__tag">{t(f.severity === "fail" ? "checks.fail" : "checks.warn")}</span>
          <span>{f.message}</span>
        </p>
      ))}
    </div>
  );
}
